export function screenSizeHeightBI(proportion) {
    var screenHeight = window.innerHeight;
    return screenHeight / proportion
}